<div class="flex flex-col gap-8 md:px-10 xl:w-[1000px]">
  <div class="flex flex-col gap-2 text-center">
    <h2 class="text-primary-900">
      {{ "calculator.excelImportHeading" | transloco }}
    </h2>
    <p class="text-paragraph-s-reg text-greyscale-700">
      {{ "calculator.excelImportSubtitle" | transloco }}
    </p>
  </div>

  @if (importing()) {
    <div class="flex flex-col items-center gap-3 py-12">
      <i
        class="pi pi-spin pi-spinner"
        style="font-size: 2rem; color: var(--color-primary-500)"
      ></i>
      <p class="text-paragraph-s-reg">
        {{ "calculator.excelImporting" | transloco }}
      </p>
    </div>
  } @else if (result()) {
    @let res = result()!;
    <div class="flex flex-col gap-4">
      <div class="rounded-lg bg-primary-50 p-4 text-center">
        <h4 class="text-primary-900">
          {{
            "calculator.excelImportSummary"
              | transloco: { created: res.createdCount, total: res.total }
          }}
        </h4>
      </div>

      @if (res.created.length) {
        <div class="flex max-h-64 flex-col gap-2 overflow-y-auto">
          @for (row of res.created; track row.tripId) {
            <div
              class="flex items-center justify-between rounded-md border border-greyscale-100 px-4 py-2"
            >
              <span class="text-paragraph-s-reg">
                {{
                  "calculator.excelRowLabel" | transloco: { row: row.rowIndex }
                }}
                — {{ row.title }}
              </span>
              <p-button
                [label]="'calculator.excelViewTrip' | transloco"
                size="small"
                [text]="true"
                (click)="viewTrip(row.tripId)"
              />
            </div>
          }
        </div>
      }

      @if (res.errors.length) {
        <div class="flex flex-col gap-2">
          <h4 class="text-error-700">
            {{ "calculator.excelImportErrorsTitle" | transloco }}
          </h4>
          @for (err of res.errors; track err.rowIndex) {
            <div
              class="rounded-md border border-error-200 bg-error-50 px-4 py-2 text-paragraph-s-reg text-error-700"
            >
              {{
                "calculator.excelRowLabel" | transloco: { row: err.rowIndex }
              }}:
              {{ err.message }}
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <div class="grid w-full grid-cols-1 gap-6 md:auto-rows-fr md:grid-cols-2">
      <!-- Flux A: deterministic template -->
      <div
        class="flex flex-col items-center gap-4 rounded-lg p-6 text-center shadow-lg"
      >
        <i
          class="pi pi-table rounded-full bg-primary-50 p-4"
          style="font-size: 2rem; color: var(--color-primary-500)"
        ></i>
        <h4>{{ "calculator.excelTemplateFlowTitle" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.excelTemplateFlowDescription" | transloco }}
        </p>
        <div class="mt-auto flex flex-col gap-2">
          <p-button
            [label]="'calculator.excelDownloadTemplate' | transloco"
            icon="pi pi-download"
            severity="secondary"
            [outlined]="true"
            [loading]="downloading()"
            (click)="downloadTemplate()"
          />
          <p-button
            [label]="'calculator.excelUploadTemplate' | transloco"
            icon="pi pi-upload"
            (click)="templateInput.click()"
          />
        </div>
        <input
          #templateInput
          type="file"
          accept=".xlsx"
          [hidden]="true"
          (change)="onFileSelected($event, 'template')"
        />
      </div>

      <!-- Flux B: AI free-form -->
      <div
        class="flex flex-col items-center gap-4 rounded-lg p-6 text-center shadow-lg"
      >
        <div
          class="flex items-center justify-center rounded-full bg-primary-50 p-4 text-primary-500"
        >
          <lucide-angular name="bot" [size]="32" />
        </div>
        <h4>{{ "calculator.excelAiFlowTitle" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.excelAiFlowDescription" | transloco }}
        </p>
        <div class="mt-auto">
          <p-button
            [label]="'calculator.excelUploadFile' | transloco"
            icon="pi pi-upload"
            (click)="aiInput.click()"
          />
        </div>
        <input
          #aiInput
          type="file"
          accept=".xlsx"
          [hidden]="true"
          (change)="onFileSelected($event, 'ai')"
        />
      </div>
    </div>
  }

  <div class="flex w-full items-center justify-between">
    @if (result()) {
      <p-button
        [label]="'back' | transloco"
        icon="pi pi-arrow-left"
        severity="secondary"
        [text]="true"
        (click)="reset()"
      />
    } @else {
      <span></span>
    }
    <p-button
      [label]="'close' | transloco"
      (click)="tripCreationModalService.close()"
      severity="secondary"
      [text]="true"
    />
  </div>
</div>
